import React, { createContext, useMemo, useContext } from 'react';
import PropTypes from 'prop-types';

import { useAuth } from '../../authentication';
import { useGetIntegrationsQuery } from '../hooks';
import { useOrganizations } from './OrganizationsProvider';

const IntegrationsContext = createContext();

const IntegrationsProvider = ({ children = null }) => {
  const { accessToken } = useAuth();
  const { currentOrganization } = useOrganizations();

  const integrationsQuery = useGetIntegrationsQuery(accessToken, currentOrganization?.id);

  const value = useMemo(
    () => ({
      integrations: integrationsQuery.data
    }),
    [integrationsQuery.data]
  );

  return <IntegrationsContext.Provider value={value}>{children}</IntegrationsContext.Provider>;
};

IntegrationsProvider.propTypes = {
  children: PropTypes.node
};

const useIntegrations = () => useContext(IntegrationsContext);

export { IntegrationsProvider, IntegrationsContext, useIntegrations };
